module.exports = __webpack_public_path__ + "static/img/label01.380fbadf.png";